import React from 'react';

//color #1B1B1B, #E25C32

const SvgIconLogoSmall = (props) => (
  <svg width="100%" height="100%" viewBox="0 0 183 35" {...props}>
    <defs>
      <path id="icon-logo-small_svg__a" d="M.103.752h21.44v33.627H.104z" />
      <path id="icon-logo-small_svg__c" d="M18.15.752h21.44v33.627H18.15z" />
    </defs>
    <g transform="translate(-.103 .012)" fill="none" fillRule="evenodd">
      <path
        fill="#1B1B1B"
        d="M49.145 3.366c-.03-.055-.058-.111-.09-.164-.486-.79-1.105-1.45-1.935-1.89-.454-.24-.938-.38-1.46-.354-.376.02-.726.122-1.012.375-.33.294-.455.676-.444 1.105.018.727.39 1.228 1.02 1.562.423.224.881.339 1.343.442.586.13 1.16.296 1.7.559.35.17.67.38.938.665.334.356.52.782.57 1.264.053.513.01 1.02-.165 1.508-.262.73-.794 1.194-1.507 1.467-.625.24-1.276.298-1.941.26a8.049 8.049 0 0 1-1.41-.196c-.612-.146-1.19-.369-1.713-.722-.04-.028-.06-.055-.06-.107l-.011-2.502.004-.057c.078.164.143.318.22.465.53 1.004 1.273 1.803 2.28 2.35.62.337 1.287.48 1.993.444a2.14 2.14 0 0 0 .68-.14c.477-.187.766-.526.83-1.04.068-.542-.073-1.015-.467-1.405a3.103 3.103 0 0 0-.84-.573 7.513 7.513 0 0 0-1.518-.53c-.587-.145-1.164-.313-1.693-.617-.523-.3-.927-.704-1.118-1.29-.13-.393-.14-.8-.1-1.208.042-.44.195-.836.472-1.183.314-.395.724-.657 1.191-.833A4.389 4.389 0 0 1 46.48.754c.76 0 1.497.128 2.206.41.139.054.274.12.41.186.022.012.047.045.047.068.003.647.002 1.294.002 1.948"
      />
      <mask id="icon-logo-small_svg__b" fill="#fff">
        <use xlinkHref="#icon-logo-small_svg__a" />
      </mask>
      <path
        fill="#E25C32"
        d="M18.718 21.297c-1.72-3.856-3.404-7.729-5.092-11.6-.636-1.457-1.281-2.912-1.863-4.391-.729-1.853-.081-3.31 1.766-4.07.495-.203 1.02-.334 1.49-.484H.104c.397.09.806.15 1.192.278.387.128.77.292 1.124.494 1.22.695 1.99 1.776 2.558 3.023 4.41 9.696 8.822 19.39 13.234 29.085.107.234.218.467.348.747l2.985-7.592-2.826-5.49z"
        mask="url(#icon-logo-small_svg__b)"
      />
      <mask id="icon-logo-small_svg__d" fill="#fff">
        <use xlinkHref="#icon-logo-small_svg__c" />
      </mask>
      <path
        fill="#E25C32"
        d="M36.765 21.297c-1.72-3.856-3.404-7.729-5.093-11.6-.635-1.457-1.28-2.912-1.862-4.391-.729-1.853-.081-3.31 1.766-4.07.495-.203 1.02-.334 1.49-.484H18.15c.398.09.807.15 1.193.278.387.128.77.292 1.124.494 1.22.695 1.99 1.776 2.557 3.023 4.411 9.696 8.823 19.39 13.235 29.085.107.234.218.467.348.747l2.985-7.592-2.826-5.49z"
        mask="url(#icon-logo-small_svg__d)"
      />
    </g>
  </svg>
);

export default SvgIconLogoSmall;
